export const DEVICE = {
  DESKTOP: 'DESKTOP',
  TABLET: 'TABLET',
  MOBILE: 'MOBILE',
};

export const DEVICE_SIZES = {
  DESKTOP: '100%',
  TABLET: '768px',
  MOBILE: '390px',
};
